import { PsResourceDocumentationState } from './PsResourceDocumentationState';
import { PsResourceDocumentAssociation } from './PsResourceDocumentAssociation';
import { PsResourceCompany } from './PsResourceCompany';

/**
 * MI recurso nunca va a tener MI esquema; como mucho el de las empresas que me han contratado.
 * En cambio, un recurso de una empresa subcontratada puede tener MI esquema y el de OTRAS empresas contratistas.
 */

export class PsResourceDocumentation {

    _state; // PsResourceDocumentationState
    _schemas; // PsResourceDocumentAssociation[]
    _mySchema; // PsResourceDocumentAssociation

    constructor(
        state,
        schemas,
        mySchema,
    ) {
        this._state = state;
        this._schemas = schemas;
        this._mySchema = mySchema;
    }

    static null() {
        return new this(
            PsResourceDocumentationState.null(),
            [],
            PsResourceDocumentAssociation.null(),
        );
    }

    static fromAPIOutsourceResource(currentUser, resource, documentationState) {
        const { contractors } = resource;
        const currentContractor = PsResourceCompany.fromAPIContractor(currentUser.contractor());
        const schemas = PsResourceDocumentAssociation.fromAPIResourceContractorSchemas(contractors);
        const mySchema = schemas.filter((s) => s.isMySchema(currentContractor))[0];
        const state = documentationState
            ? PsResourceDocumentationState.fromAPIDocumentationState(documentationState)
            : PsResourceDocumentationState.null();

        return new this(
            state,
            schemas,
            mySchema ? mySchema : PsResourceDocumentAssociation.null(),
        );
    }

    static fromAPIContractorResource(contractors, documentationState) {
        const schemas = PsResourceDocumentAssociation.fromAPIResourceContractorSchemas(contractors);
        const state = documentationState
            ? PsResourceDocumentationState.fromAPIDocumentationState(documentationState)
            : PsResourceDocumentationState.null();

        return new this(
            state,
            schemas,
            PsResourceDocumentAssociation.null(),
        );
    }

    state() {
        return this._state;
    }

    schemas() {
        return this._schemas;
    }

    mySchema() {
        return this._mySchema;
    }

    mySchemaDescription() {
        return this.mySchema().documentDescription();
    }

    schemasDescription() {
        return this
            .schemas()
            .map((schema) => schema.completeDescription());
    }

    schemasPosition() {
        return this
            .schemas()
            .map((schema) => schema.completePosition());
    }

    stateData() {
        return this.state().data();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/resource/PsResourceDocumentation.js